import administracion from "./administracion/administracion"
import audiencias from "./audiencias/audiencias"
import consultas from "./consultas/consultas"
import transmision from "./transmision/transmision"
import estadisticos from "./estadisticos/estadisticos"

const forseti = {
  administracion: administracion,
  audiencias: audiencias,
  consultas: consultas,
  transmision: transmision,
  estadisticos: estadisticos
}

export default forseti



//////////////////
// WEBPACK FOOTER
// ./static/js/api/forseti/sistema/forseti.js
// module id = null
// module chunks = 